import React, { useEffect, useState } from "react";
import { getNextBookingsByUserId } from "../components/services/BookingService";
import { Booking } from "../components/models/booking";
import Cookies from 'js-cookie';
import BookingItemNext from "../components/booking/components/items/BookingItemNext"



const UserNextRidesPage: React.FC = () => {

  const [bookings, setBookings] = useState<Booking[]>([]);
  const userId = Cookies.get('loggedUserId');

  const getUserNextRide = async () => {
    let bookings;
    if (userId) {

      bookings = await getNextBookingsByUserId(userId);
      if (bookings) {
        setBookings(bookings)
      }

    }
  };

  useEffect(() => {
    getUserNextRide();
  }, []);

  return (
    <div className="mt-2" style={{ fontFamily: "'Segoe UI', 'Roboto', sans-serif" }}>
      <div className="container mt-4">
        <div
          className="d-flex align-items-center bg-white border-0 rounded-top user-select-none border-start border-4 border-primary px-2 py-2"
          style={{ letterSpacing: '0.05em' }}
        >
          <h5 className="mb-0 fw-bold text-dark ps-2" style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
            Your Upcoming Bookings
    </h5>
        </div>
      </div>



      <hr className="my-0" />
      <div className="mt-3">
        <BookingItemNext bookings={bookings} />
      </div>
    </div>
  );
};

export default UserNextRidesPage;
